export default __webpack_public_path__ + "static/media/en.d916ad99.svg";